<template>
  <div class="piece-card">
    <div
      class="piece-card-top"
      :class="{ 'piece-card-link': !!route || canClickTitle, 'hide-line': hideLine }"
      @click="handleClick"
    >
      <img :src="icon" class="piece-card-icon" />
      <div class="piece-card-title">{{ title }}</div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import cloudIcon from "@/assets/classroom/cloud.png";

export default {
  name: "PieceCard",
  props: {
    title: { type: String, default: "" },
    icon: { type: String, default: cloudIcon },
    route: { type: Object },
    // 能否点击标题事件
    canClickTitle: { type: Boolean },
    hideLine: { type: Boolean },
  },
  data() {
    return {};
  },
  methods: {
    handleClick() {
      this.$router.push(this.route);
    },
  },
};
</script>

<style lang="less" scoped>
.piece-card-top {
  display: flex;
  align-items: center;
  position: relative;
  padding: 0 3px 8px;
  overflow: hidden;
  margin-bottom: 8px;
  &.hide-line {
    &::after {
      display: none;
    }
  }
  &::after {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    bottom: 0;
    width: 436px;
    height: 4px;
    background: url(../../../../assets/classroom/card_line.png) center / 100% 100% no-repeat;
  }
  &.piece-card-link {
    cursor: pointer;
  }
}
.piece-card-icon {
  width: 24px;
  height: 24px;
}
.piece-card-title {
  margin-left: 12px;
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
  color: #fff;
}
</style>
